export type TimeWindow = {
  startMs: number;
  endMs: number;
};

export function getReservationTimeWindow(input: {
  time: string;
  duration_mins: number;
}): TimeWindow {
  const startMs = Date.parse(input.time);
  if (!Number.isFinite(startMs)) {
    throw new Error("Invalid reservation time");
  }
  return {
    startMs,
    endMs: startMs + input.duration_mins * 60_000,
  };
}

/**
 * Half-open interval overlap: [start, end). Adjacent windows do not overlap.
 */
export function timeWindowsOverlap(a: TimeWindow, b: TimeWindow): boolean {
  return a.startMs < b.endMs && a.endMs > b.startMs;
}
